module.exports = __webpack_public_path__ + "img/logo.3e7800d0.png";